module.exports = __webpack_public_path__ + "media/src/site/images/searching-6abefd451085322d45e71128ef2339ad.gif";